var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 318,
    viewBox: "0 0 910 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 785.319,
    cy: 7.4644,
    r: 6.51885,
    transform: "rotate(15 785.319 7.4644)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779.534,
    cy: 29.0545,
    r: 6.51885,
    transform: "rotate(15 779.534 29.0545)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.75,
    cy: 50.6429,
    r: 6.51885,
    transform: "rotate(15 773.75 50.6429)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.965,
    cy: 72.231,
    r: 6.51885,
    transform: "rotate(15 767.965 72.231)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762.18,
    cy: 93.8191,
    r: 6.51885,
    transform: "rotate(15 762.18 93.8191)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756.396,
    cy: 115.409,
    r: 6.51885,
    transform: "rotate(15 756.396 115.409)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.975,
    cy: -6.4482,
    r: 6.51885,
    transform: "rotate(15 387.975 -6.4482)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.191,
    cy: 15.1402,
    r: 6.51885,
    transform: "rotate(15 382.191 15.1402)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.647,
    cy: 0.50908,
    r: 6.51885,
    transform: "rotate(15 586.647 0.50908)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.863,
    cy: 22.0972,
    r: 6.51885,
    transform: "rotate(15 580.863 22.0972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.078,
    cy: 43.6856,
    r: 6.51885,
    transform: "rotate(15 575.078 43.6856)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.293,
    cy: 65.2757,
    r: 6.51885,
    transform: "rotate(15 569.293 65.2757)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.655,
    cy: 10.9439,
    r: 6.51885,
    transform: "rotate(15 884.655 10.9439)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.87,
    cy: 32.5323,
    r: 6.51885,
    transform: "rotate(15 878.87 32.5323)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.086,
    cy: 54.1204,
    r: 6.51885,
    transform: "rotate(15 873.086 54.1204)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 867.301,
    cy: 75.7088,
    r: 6.51885,
    transform: "rotate(15 867.301 75.7088)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.516,
    cy: 97.2989,
    r: 6.51885,
    transform: "rotate(15 861.516 97.2989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.731,
    cy: 118.887,
    r: 6.51885,
    transform: "rotate(15 855.731 118.887)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.947,
    cy: 140.475,
    r: 6.51885,
    transform: "rotate(15 849.947 140.475)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.311,
    cy: -2.97041,
    r: 6.51885,
    transform: "rotate(15 487.311 -2.97041)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 481.527,
    cy: 18.6197,
    r: 6.51885,
    transform: "rotate(15 481.527 18.6197)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.742,
    cy: 40.2078,
    r: 6.51885,
    transform: "rotate(15 475.742 40.2078)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 685.983,
    cy: 3.98686,
    r: 6.51885,
    transform: "rotate(15 685.983 3.98686)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.198,
    cy: 25.575,
    r: 6.51885,
    transform: "rotate(15 680.198 25.575)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.414,
    cy: 47.1651,
    r: 6.51885,
    transform: "rotate(15 674.414 47.1651)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.629,
    cy: 68.7535,
    r: 6.51885,
    transform: "rotate(15 668.629 68.7535)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.844,
    cy: 90.3416,
    r: 6.51885,
    transform: "rotate(15 662.844 90.3416)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.88,
    cy: -1.5898,
    r: 6.51885,
    transform: "rotate(15 837.88 -1.5898)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.095,
    cy: 19.9983,
    r: 6.51885,
    transform: "rotate(15 832.095 19.9983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826.31,
    cy: 41.5865,
    r: 6.51885,
    transform: "rotate(15 826.31 41.5865)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.525,
    cy: 63.1766,
    r: 6.51885,
    transform: "rotate(15 820.525 63.1766)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.741,
    cy: 84.7649,
    r: 6.51885,
    transform: "rotate(15 814.741 84.7649)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.956,
    cy: 106.353,
    r: 6.51885,
    transform: "rotate(15 808.956 106.353)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803.171,
    cy: 127.943,
    r: 6.51885,
    transform: "rotate(15 803.171 127.943)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.751,
    cy: 6.08574,
    r: 6.51885,
    transform: "rotate(15 434.751 6.08574)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.966,
    cy: 27.6741,
    r: 6.51885,
    transform: "rotate(15 428.966 27.6741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.423,
    cy: 13.0411,
    r: 6.51885,
    transform: "rotate(15 633.423 13.0411)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 627.638,
    cy: 34.6311,
    r: 6.51885,
    transform: "rotate(15 627.638 34.6311)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.853,
    cy: 56.2195,
    r: 6.51885,
    transform: "rotate(15 621.853 56.2195)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 616.069,
    cy: 77.8077,
    r: 6.51885,
    transform: "rotate(15 616.069 77.8077)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914.077,
    cy: 88.2425,
    r: 6.51885,
    transform: "rotate(15 914.077 88.2425)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.292,
    cy: 109.833,
    r: 6.51885,
    transform: "rotate(15 908.292 109.833)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902.507,
    cy: 131.421,
    r: 6.51885,
    transform: "rotate(15 902.507 131.421)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.723,
    cy: 153.009,
    r: 6.51885,
    transform: "rotate(15 896.723 153.009)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534.087,
    cy: 9.56352,
    r: 6.51885,
    transform: "rotate(15 534.087 9.56352)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.302,
    cy: 31.1517,
    r: 6.51885,
    transform: "rotate(15 528.302 31.1517)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522.517,
    cy: 52.7417,
    r: 6.51885,
    transform: "rotate(15 522.517 52.7417)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.414,
    cy: 2.60796,
    r: 6.51885,
    transform: "rotate(15 335.414 2.60796)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738.544,
    cy: -5.06953,
    r: 6.51885,
    transform: "rotate(15 738.544 -5.06953)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.759,
    cy: 16.5206,
    r: 6.51885,
    transform: "rotate(15 732.759 16.5206)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726.974,
    cy: 38.1089,
    r: 6.51885,
    transform: "rotate(15 726.974 38.1089)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 721.189,
    cy: 59.6971,
    r: 6.51885,
    transform: "rotate(15 721.189 59.6971)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715.405,
    cy: 81.2872,
    r: 6.51885,
    transform: "rotate(15 715.405 81.2872)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709.62,
    cy: 102.876,
    r: 6.51885,
    transform: "rotate(15 709.62 102.876)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 814.492,
    cy: -7.85786,
    r: 6.51885,
    transform: "rotate(15 814.492 -7.85786)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.707,
    cy: 13.7322,
    r: 6.51885,
    transform: "rotate(15 808.707 13.7322)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.922,
    cy: 35.3206,
    r: 6.51885,
    transform: "rotate(15 802.922 35.3206)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 797.138,
    cy: 56.9087,
    r: 6.51885,
    transform: "rotate(15 797.138 56.9087)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 791.353,
    cy: 78.4988,
    r: 6.51885,
    transform: "rotate(15 791.353 78.4988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.568,
    cy: 100.087,
    r: 6.51885,
    transform: "rotate(15 785.568 100.087)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779.783,
    cy: 121.675,
    r: 6.51885,
    transform: "rotate(15 779.783 121.675)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.363,
    cy: -0.182083,
    r: 6.51885,
    transform: "rotate(15 411.363 -0.182083)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.578,
    cy: 21.408,
    r: 6.51885,
    transform: "rotate(15 405.578 21.408)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.035,
    cy: 6.77519,
    r: 6.51885,
    transform: "rotate(15 610.035 6.77519)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.25,
    cy: 28.3633,
    r: 6.51885,
    transform: "rotate(15 604.25 28.3633)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.466,
    cy: 49.9534,
    r: 6.51885,
    transform: "rotate(15 598.466 49.9534)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.681,
    cy: 71.5415,
    r: 6.51885,
    transform: "rotate(15 592.681 71.5415)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913.828,
    cy: -4.37813,
    r: 6.51885,
    transform: "rotate(15 913.828 -4.37813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 908.043,
    cy: 17.21,
    r: 6.51885,
    transform: "rotate(15 908.043 17.21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902.258,
    cy: 38.7981,
    r: 6.51885,
    transform: "rotate(15 902.258 38.7981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 896.474,
    cy: 60.3882,
    r: 6.51885,
    transform: "rotate(15 896.474 60.3882)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890.689,
    cy: 81.9766,
    r: 6.51885,
    transform: "rotate(15 890.689 81.9766)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 884.904,
    cy: 103.565,
    r: 6.51885,
    transform: "rotate(15 884.904 103.565)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 879.12,
    cy: 125.153,
    r: 6.51885,
    transform: "rotate(15 879.12 125.153)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.335,
    cy: 146.743,
    r: 6.51885,
    transform: "rotate(15 873.335 146.743)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510.699,
    cy: 3.29741,
    r: 6.51885,
    transform: "rotate(15 510.699 3.29741)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504.914,
    cy: 24.8855,
    r: 6.51885,
    transform: "rotate(15 504.914 24.8855)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.13,
    cy: 46.4739,
    r: 6.51885,
    transform: "rotate(15 499.13 46.4739)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.027,
    cy: -3.65987,
    r: 6.51885,
    transform: "rotate(15 312.027 -3.65987)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 709.371,
    cy: 10.2527,
    r: 6.51885,
    transform: "rotate(15 709.371 10.2527)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.586,
    cy: 31.8428,
    r: 6.51885,
    transform: "rotate(15 703.586 31.8428)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.802,
    cy: 53.4312,
    r: 6.51885,
    transform: "rotate(15 697.802 53.4312)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 692.017,
    cy: 75.0193,
    r: 6.51885,
    transform: "rotate(15 692.017 75.0193)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686.232,
    cy: 96.6094,
    r: 6.51885,
    transform: "rotate(15 686.232 96.6094)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 861.267,
    cy: 4.67607,
    r: 6.51885,
    transform: "rotate(15 861.267 4.67607)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 855.483,
    cy: 26.2645,
    r: 6.51885,
    transform: "rotate(15 855.483 26.2645)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.698,
    cy: 47.8545,
    r: 6.51885,
    transform: "rotate(15 849.698 47.8545)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.913,
    cy: 69.4427,
    r: 6.51885,
    transform: "rotate(15 843.913 69.4427)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 838.128,
    cy: 91.0311,
    r: 6.51885,
    transform: "rotate(15 838.128 91.0311)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832.344,
    cy: 112.621,
    r: 6.51885,
    transform: "rotate(15 832.344 112.621)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826.559,
    cy: 134.209,
    r: 6.51885,
    transform: "rotate(15 826.559 134.209)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.139,
    cy: 12.3519,
    r: 6.51885,
    transform: "rotate(15 458.139 12.3519)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.354,
    cy: 33.9419,
    r: 6.51885,
    transform: "rotate(15 452.354 33.9419)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.595,
    cy: -2.27925,
    r: 6.51885,
    transform: "rotate(15 662.595 -2.27925)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.811,
    cy: 19.3089,
    r: 6.51885,
    transform: "rotate(15 656.811 19.3089)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651.026,
    cy: 40.8973,
    r: 6.51885,
    transform: "rotate(15 651.026 40.8973)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.241,
    cy: 62.4854,
    r: 6.51885,
    transform: "rotate(15 645.241 62.4854)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.456,
    cy: 84.0755,
    r: 6.51885,
    transform: "rotate(15 639.456 84.0755)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 563.259,
    cy: -5.75874,
    r: 6.51885,
    transform: "rotate(15 563.259 -5.75874)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.475,
    cy: 15.8313,
    r: 6.51885,
    transform: "rotate(15 557.475 15.8313)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 551.69,
    cy: 37.4195,
    r: 6.51885,
    transform: "rotate(15 551.69 37.4195)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545.905,
    cy: 59.0079,
    r: 6.51885,
    transform: "rotate(15 545.905 59.0079)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.802,
    cy: 8.87407,
    r: 6.51885,
    transform: "rotate(15 358.802 8.87407)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.931,
    cy: 1.19853,
    r: 6.51885,
    transform: "rotate(15 761.931 1.19853)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756.147,
    cy: 22.7867,
    r: 6.51885,
    transform: "rotate(15 756.147 22.7867)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750.362,
    cy: 44.3748,
    r: 6.51885,
    transform: "rotate(15 750.362 44.3748)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 744.577,
    cy: 65.9649,
    r: 6.51885,
    transform: "rotate(15 744.577 65.9649)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738.792,
    cy: 87.5533,
    r: 6.51885,
    transform: "rotate(15 738.792 87.5533)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 733.008,
    cy: 109.141,
    r: 6.51885,
    transform: "rotate(15 733.008 109.141)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDots);
export default __webpack_public_path__ + "static/media/angle-dots.fedbfbcdcd8354fe761c9f551419db76.svg";
export { ForwardRef as ReactComponent };